import { IWarning, WarningLoadingState } from 'redux-state/weather-warnings/types.js';
import { ISeverity } from 'utilities/weather-warnings/warning-severity.js';

export interface IWarningForDays {
  warnings: IWarning[];
  colorClass: string;
  severityLevel: ISeverity;
  date?: Date;
  dateString: string;
}

export interface IUseWarningsType {
  warnings: IWarning[];
  state: WarningLoadingState;
}

export function isValidDate(date: Date | undefined): date is Date {
  return date instanceof Date && date.toString() !== 'Invalid Date';
}

export const getWarningsClassByIndex =
  (warningsDays: IWarningForDays[] | undefined) =>
  (dateISO: string): string => {
    const uniqueHeader = warningsDays?.find((a) => a.dateString === dateISO)?.colorClass;
    return uniqueHeader ?? '';
  };

export const getWarningsByDate = (
  warningsDays: IWarningForDays[] | undefined,
  dateISO: string,
): IWarning[] | undefined => {
  const date = dateISO ? new Date(dateISO) : undefined;
  if (isValidDate(date)) {
    const warnings = warningsDays?.filter((w) => w.date?.getTime() === date.getTime());

    if ((warnings?.length ?? 0) > 1) {
      console.log('warnings error', warnings);
    }
    return warnings?.[0]?.warnings ?? undefined;
  }
  return undefined;
};
